import { useState } from 'react'
import ReportModal from './ReportModal'
import { FlagIcon } from '@heroicons/react/24/outline'

const ReportButton = ({ contentId, contentType, reportTarget }) => {
  const [showReportModal, setShowReportModal] = useState(false)
  return (
    <>
      <button
        onClick={() => setShowReportModal(true)}
        className="bg-background/90 backdrop-blur-sm rounded-full p-2 shadow-sm "
      >
        <FlagIcon className="w-6 h-6 text-secondary-600" />
      </button>

      <ReportModal
        isOpen={showReportModal}
        onClose={() => setShowReportModal(false)}
        contentId={contentId}
        contentType={contentType}
        reportTarget={reportTarget}
      />
    </>
  )
}
export default ReportButton
